$(document).ready(function() {
  if ($('body').hasClass('id-1')) {
    $('.home-box').insertBefore('.homepage-products-heading-1')
    $('.welcome .small__category').insertAfter('.home-box')
    $('.production__wrapper').insertAfter('.small__category')

    $(
      '<div class=\'listItemMobil\'><div class=\'mobilItem\'><a href=\'/matrace/\'><div class=\'imageItem\'><img src=\'/user/documents/upload/banMobil/banMatrace.jpg\' alt=\'\' /></div><div class=\'textItem\'>Matrace</div></a></div><div class=\'mobilItem\'><a href=\'/postele/\'><div class=\'imageItem\'><img src=\'/user/documents/upload/banMobil/banPostel-2.jpg\' alt=\'\' /></div><div class=\'textItem\'>Postele</div></a></div><div class=\'mobilItem\'><a href=\'/lamelove-rosty/\'><div class=\'imageItem\'><img src=\'/user/documents/upload/banMobil/banRost.jpg\' alt=\'\' /></div><div class=\'textItem\'>Rošty</div></a></div><div class=\'mobilItem\'><a href=\'https://www.vyspimese.cz/komody/\'><div class=\'imageItem\'><img src=\'/user/documents/upload/temp/mob/komody.png\' alt=\'\' /></div><div class=\'textItem\'>Komody</div></a></div><div class=\'mobilItem\'><a href=\'https://www.vyspimese.cz/polstare-a-prikryvky/\'><div class=\'imageItem\'><img src=\'/user/documents/upload/temp/mob/polstare.png\' alt=\'\' /></div><div class=\'textItem\'>Polštáře</div></a></div><div class=\'mobilItem\'><a href=\'https://www.vyspimese.cz/luzkoviny/\'><div class=\'imageItem\'><img src=\'/user/documents/upload/temp/mob/luzkoviny_1.png\' alt=\'\' /></div><div class=\'textItem\'>Lůžkoviny</div></a></div><div class=\'mobilItem\'><a href=\'https://www.vyspimese.cz/prikryvky/\'><div class=\'imageItem\'><img src=\'/user/documents/upload/temp/prikryvka.png\' alt=\'\' /></div><div class=\'textItem\'>Přikrývky</div></a></div><div class=\'mobilItem\'><a href=\'https://www.vyspimese.cz/nabytek-2/\'><div class=\'imageItem\'><img src=\'https://cdn.myshoptet.com/usr/www.vyspimese.cz/user/shop/detail/152016_komoda-bmb-radiusove-hrany.jpg\' alt=\'\' /></div><div class=\'textItem\'>Nábytek</div></a></div></div>'
    ).insertAfter('.wide-carousel')

    $('.alertText').insertAfter('.wide-carousel')

    $('.search input').attr('placeholder', 'Spolu to najdeme')
  }

  // header
  if ($(window).width() > 1200) {
    $(
      '<div class="contact-info">' +
      '  <div class="phone">' +
      '    <img src="https://www.vyspimese.cz/user/documents/upload/temp/top/icon-phone.svg" alt="Phone">' +
      '    <a href="tel:+420608223270">+420 608 223 270</a>' +
      '  </div>' +
      '  <div class="email">' +
      '    <img src="https://www.vyspimese.cz/user/documents/upload/temp/top/icon-mail.svg" alt="Email">' +
      '    <a href="mailto:info@vyspimese.cz">info@vyspimese.cz</a>' +
      '  </div>' +
      '  <div class="locations">' +
      '    <img src="https://www.vyspimese.cz/user/documents/upload/temp/top/icon-shop.svg" alt="Locations">' +
      '    <a href="https://www.vyspimese.cz/pobocky/">4 pobočky v ČR</a>' +
      '  </div>' +
      '  <div class="about-us">' +
      '    <img src="https://www.vyspimese.cz/user/documents/upload/temp/top/o-nas.svg" alt="Locations">' +
      '    <a href="https://www.vyspimese.cz/o-nas-vyspimese/">O nás</a>' +
      '  </div>' +
      '</div>'
    ).appendTo('.top-navigation-bar .container .top-navigation-contacts')
  }
})

// linkReg
$(document).ready(function() {
  $(window).width() > 767 &&
  $(
    '<div class=\'link-reg\'><div><a href=\'/registrace/\'>Registrace</a></div></div>'
  ).insertBefore('.top-navigation-bar .top-nav-button-login')
})

// doporučujeme
$(document).on('ready ShoptetDOMContentLoaded', function() {
  $('<h4 class="open">Doporučujeme <span class="submenu-arrow"></span></h4>').appendTo(
    'body.mobile .category-header'
  )
  $('body.mobile .category-header').each(function() {
    let tableT = $(this).find('h4')
    let titleT = $(this).find('form')

    $(titleT).hide()

    $(tableT).on('click', function() {
      $(titleT).fadeToggle()
    })
  })
})

// min768px
if (window.matchMedia('(min-width: 768px)').matches) {
  $('<div class="desktop-anime-1"></div>').insertBefore('#navigation')
}

// max768px
if (window.matchMedia('(max-width: 768px)').matches) {
  $('<div class="contact-info"><div class="phone"><img src="https://www.vyspimese.cz/user/documents/upload/temp/top/icon-phone.svg" alt="Phone" loading="eager"><a href="tel:+420608223270">+420 608 223 270</a></div> <div class="email"><img src="https://www.vyspimese.cz/user/documents/upload/temp/top/icon-mail.svg" alt="Email" loading="eager"><a href="mailto:info@vyspimese.cz">info@vyspimese.cz</a></div> <div class="locations"><img src="https://www.vyspimese.cz/user/documents/upload/temp/top/icon-shop.svg" alt="Locations" loading="eager"><a href="https://www.vyspimese.cz/pobocky/">4 pobočky v ČR</a></div> <div class=""><img src="https://www.vyspimese.cz/user/documents/upload/temp/top/o-nas.svg" alt="Locations"><a href="https://www.vyspimese.cz/o-nas-vyspimese/">O nás</a></div></div>').appendTo('nav#navigation .navigation-in.menu')
}

// max768px
if (window.matchMedia('(max-width: 768px)').matches) {
  $('<div class="mob-anime-1"></div>').insertAfter(
    '.id-1 .s-1.shop--box, .id-1 .s-2.shop--box ,.id-1 .s-3.shop--box'
  )
  $('<div class="mob-anime-2"></div>').insertAfter('.type-category .category-header')
}

// ratingWrapper
$(function() {

  $('<div class="my-evaluations-container"><div class="rating-wrapper"><div class="first"></div><div class="last"></div></div></div>')
    .insertBefore('footer')


  $('<div>').hide().appendTo('body').load(
    '/hodnoceni-obchodu/ #ratingWrapper, .votes-wrap.simple-vote:not(.admin-response)',
    function() {
      $('.first').append($('#ratingWrapper', this))
      $('.last').append(
        $('.votes-wrap.simple-vote .vote-wrap[data-testid="gridRating"]', this)
          .slice(0, 4)
      )
      $(this).remove()
    }
  )
})

